module.exports = __webpack_public_path__ + "assets/salmon.96a4a179.svg";